import { io } from "socket.io-client";

/** Login stores `user_id`; some paths still read `userId` — both must register the socket user. */
export const getStoredUserId = () =>
  localStorage.getItem("user_id") || localStorage.getItem("userId");

const SOCKET_SERVER_URL =
  process.env.REACT_APP_QL_API_SOCKET_URL ?? "http://localhost:3000";
export const socket = io(SOCKET_SERVER_URL, {
  transports: ["websocket"],      // skip long-polling fallback
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 1000,
  autoConnect: true,              // default; connects as soon as ctor runs
  timeout: 10000,                 // fail a single attempt after 10 s
});

socket.on("connect", () => {
  console.log("✅ Socket connected:", socket.id);

  const userId = getStoredUserId();
  if (userId) {
    socket.emit("registerUser", userId);
  } else {
    console.warn(
      "[chat-socket] connect: no user id in localStorage (expected user_id or userId); registerUser skipped"
    );
  }
});

socket.on("disconnect", (reason) => {
  console.warn("⚠️ Socket disconnected:", reason);
});

socket.on("connect_error", (err) => {
  console.error("[chat-socket] connect_error:", err.message, SOCKET_SERVER_URL);
});

socket.io.on("reconnect_attempt", (attempt) => {
  console.log(`🔄 Reconnect attempt #${attempt + 1}…`);
});
